import { Checkmark } from 'assets/icons/Checkmark';
import cn from 'classnames';
import { RewardConditionProps } from 'features/RewardCard/RewardCard.types';
import { AnimatePresence, motion } from 'framer-motion';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export const RewardCondition = memo(({ isComplete, title, description, icon }: RewardConditionProps) => {
	const { t } = useTranslation();
	return (
		<li
			className={cn(
				'grid grid-cols-[auto,1fr] text-paragraph-xs',
				isComplete ? 'text-gray-700 dark:text-gray-300' : 'text-gray-900 dark:text-gray-100',
			)}
		>
			<div className="w-5 h-5 flex items-center justify-center">
				<AnimatePresence exitBeforeEnter>
					<motion.div
						key={isComplete ? 'check' : 'icon'}
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.2 }}
						className="w-5 h-5 flex items-center justify-center"
					>
						{isComplete ? <Checkmark className="stroke-gray-700 w-3 h-3" /> : icon}
					</motion.div>
				</AnimatePresence>
			</div>

			<div className="flex flex-col">
				<div className="flex flex-wrap gap-x-1 leading-5">
					<span className="font-semibold">{t(title)}</span>
				</div>
				{description && <div className="font-semibold text-paragraph-xs text-left">({description}):</div>}
			</div>
		</li>
	);
});
